import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../services/dashboard.service';

@Component({
  selector: 'app-barcode-reader',
  templateUrl: './barcode-reader.component.html',
  styleUrls: ['./barcode-reader.component.scss']
})
export class BarcodeReaderComponent implements OnInit {

  constructor(private dashboardService: DashboardService) { }
  DeliveryCode: string = ""
  ShowNotfound: boolean = false
  ngOnInit() {
    this.dashboardService.getDeliveryCode((res) => {
      this.DeliveryCode = res;
      if (res == "") {
        this.ShowNotfound = true;
      }
      
      //console.log(res)
    }, () => {

    });
  }

}
